<template>
  <div class="page">
    <div class="top">
      <img src="./img/ok.png"
           class="success_icon"/>
      <p>登陆成功</p>
      <span>恭喜您，可以安全使用Runway中文站</span>
      <div class="btn">
        <div class="item" @click="handleJump('/')">
          作品广场
        </div>
        <div class="item" @click="handleJump('/mine')">
          会员中心
        </div>
        <div class="item active" @click="handleJump('/creation')">
          开始创作
          <img src="./img/img_icon_02.gif" class="hot"/>
        </div>
      </div>
    </div>
    <div class="code">
      <div class="icon">
        <p>Runway中文站</p>
      </div>
      <span>Runway中文站，行业公认质量较高的Ai创作软件</span>
      <div class="img_num">
        <div>
          <p>{{ total_num }} <span>条</span> </p>
          <span>累计创作数量</span>
        </div>
        <div>
          <p>{{docnum  }} <span>条</span></p>
          <span>{{ currentMonth }}月{{ currentDate }}日Ai创作数量</span>
        </div>
      </div>
    </div>
    <!--    <videoPlayer ref="videoPlayer"-->
    <!--                 @closePlayer="closePlayer"-->
    <!--                 v-show="videoPlay"-->
    <!--                 :video_url="'https://cdnjindouyuan202105.m.nengshuohuihua.com/ad/help_'+site_logo+'.mp4'"></videoPlayer>-->
  </div>
</template>

<script>
// import videoPlayer from '@/components/VideoPlayer.vue'
export default {
  components: {
    // videoPlayer,
  },
  data() {
    return {
      videoPlay: false,
      // site_name: SITE_NAME,
      // site_logo: SITE_LOGO,
      currentMonth: '', // 当前月份
      currentDate: '',  // 当前日期
      docnum: 0,
      total_num:0,
    }
  },
  computed: {
      userInfo() {
          return this.$store.state.userInfo;
      },
      isLogin() {
          return this.$store.state.isLogin;
      }
  },
  created() {
   
    // 当前时间
    const now = new Date();
    this.currentMonth = now.getMonth() + 1; // getMonth() 返回的月份是从 0 开始的，所以需要加 1
    this.currentDate = now.getDate();

    this.$http.get(`/front/aivideo/draw/num/`).then((res) => {
        this.total_num = res.data.total_num;
        let today_doc_num = res.data.today_doc_num;
        let step = parseInt(today_doc_num / 20);
        let timer = setInterval(() => {
          this.docnum = this.docnum + step;
          if (this.docnum > today_doc_num) {
            this.docnum = today_doc_num;
            clearInterval(timer);
          }
        }, 100)
      })
    this.fetchProfile()
  },
  methods: {
    getUrlParams(url) {
      // 通过 ? 分割获取后面的参数字符串
      let urlStr = url.split('?')[1]
      // 创建空对象存储参数
      let obj = {};
      // 再通过 & 将每一个参数单独分割出来
      if (urlStr) {
        let paramsArr = urlStr.split('&')
        for (let i = 0, len = paramsArr.length; i < len; i++) {
          // 再通过 = 将每一个参数分割为 key:value 的形式
          let arr = paramsArr[i].split('=')
          obj[arr[0]] = arr[1];
        }
      }
      return obj
    },
    fetchProfile() {
      this.$http.get('/front/user/profile/').then(res => {
        if (res.status == '200') {
          this.$store.commit("setUserInfo", res.data);
          this.$store.commit("setIsLogin", true);
          if(localStorage.getItem('isREQre')){
              localStorage.removeItem('isREQre')
              // location.href = '/reqrefund'
              this.$router.push('/reqrefund')
          }
        }
      })
    },
    //点击播放视频
    play() {
      this.videoPlay = true
      this.$nextTick(() => {
        this.$refs.videoPlayer.play();
      })
    },
    //关闭视频
    closePlayer() {
      this.videoPlay = false
    },
    //跳转
    handleJump(url) {
      let token = localStorage.getItem("token") || ""
      // if (this.isLogin) {
      if(token){
        // this.$router.push(url)
        let token = localStorage.getItem("token")
        window.location.href = `${API_SERVER}/square?token=${token}`
      }else{
        window.location.href = `${API_SERVER}/api/wx/oauth/?appid=${APP_ID}`
      }
    },

  }
}

</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.page {
  background-color: white;
  height: 100vh;
  overflow-y: auto;
}

.top {
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
  padding: 50px 0 30px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .success_icon {
    width: 50px;
    height: 50px;
  }

  p {
    font-size: 18px;
    font-weight: bold;
    color: #ec3b3b;
    padding: 30px 0;
  }

  span {
    font-size: 14px;
    color: #b9b9b9;
  }

  .btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 32px;
    margin-top: 40px;

    .item {
      background: #fff;
      flex: 0 0 30%;
      line-height: 40px;
      border-radius: 6px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px dotted #999;
      //font-size: 18px;
      color: black;
      .icon {
        width: 16px;
        height: 16px;
        margin-right: 10px;
        position: relative;
        top: 0;
      }

      .hot {
        position: absolute;
        right: 3px;
        top: -2px;
        width: 25px;
        height: 14px;
      }

      &.active {
        //padding-right: 10px;
        border-color: #ec3b3b;
        color: #ec3b3b;
        background: #fdd4d4;
      }
    }
  }
}

.code {
  padding: 45px 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .icon {
    display: flex;
    align-items: center;

    img {
      width: 30px;
    }
  }

  p {
    font-size: 18px;
    color: black;
  }

  span {
    margin: 30px 0;
    color: #b9b9b9;
    font-size: 12px;
  }

  .img_num{
    //color: black;
    display: flex;
    width: 100%;
    margin-top: 20px;
    justify-content: space-evenly;

    div {
      //color:#ff2b2b ;
      display: flex;
      flex-direction: column;
      align-items: center;

      p {
        font-size: 20px;
        margin-bottom: 20px;
      }

      span {
        margin: 10px 0;
        font-size: 14px;
      }
    }
    div:nth-child(1) {
      color: #ff2b2b;
      p{
        color: #575757;
      }
      span{
        color: #575757;
      }
    }
    div:nth-child(2) {
      color: #ff2b2b;
      p{
        color: #ff2b2b;
      }
      span{
        color: #ff2b2b;
      }
    }
  }

}

</style>

